import React from "react";
import type { RecommerceAd } from "../types";
import { useAdContext } from "./AdContext";
import { AdLink } from "./AdLink";

export type AdTitleProps = {
	ad: RecommerceAd;
	className?: string;
	heading?: (props: SearchAdHeadingProps) => React.ReactElement | null;
};

export function AdTitle(props: AdTitleProps) {
	const { ad, className = "", heading } = props;

	const headingText = ad.heading || "\u00A0";
	const headingProps: SearchAdHeadingProps = {};

	// Ad header is shown over two lines, and additional vertical space is
	// added for short titles.
	const hasLineClamp = className && /\bline-clamp-\d+\b/.test(className);
	headingProps.className = `${className} ${hasLineClamp ? "" : "line-clamp-2"}`;

	return heading ? heading(headingProps) : <SearchAdHeading {...headingProps}>{headingText}</SearchAdHeading>;
}

export type SearchAdHeadingProps = {
	as?: string;
	children?: React.ReactNode;
	className?: string;
	linkClass?: string;
};

function SearchAdHeading(props: SearchAdHeadingProps) {
	const { as = "h2", children, className, linkClass = "" } = props;

	const { headingId, linkId } = useAdContext();
	const headingClass = `h4 mb-0 ${className ?? ""}`;

	return React.createElement(
		as,
		{ className: headingClass, id: headingId },
		<AdLink className={`s-text! hover:no-underline ${linkClass}`} id={linkId}>
			{children}
		</AdLink>,
	);
}
